<template>
	<div>
		<span class="text-[var(--text-primary)] font-semibold">
			{{ getLoanOfferName(message.properties["type"]) }}
		</span>
		<span> ontvangen</span>
	</div>
</template>

<script setup lang="ts">
import { getLoanOfferName } from "@/helpers/hdnHelpers";
import type { LoanApplicationOfferMessage } from "@/models/LoanApplicationStatusMessage";

defineProps<{
	message: LoanApplicationOfferMessage;
}>();
</script>
